import { formatNumber } from "@goodfill/format-number";
import React from "react";

interface Props {
  value: number;
}

export const formatYearsHeld = ({ value }: Props) =>
  formatNumber({ value, minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const YearsHeldComponent: React.FC<Props> = (props) => {
  return <>{formatYearsHeld(props)}</>;
};
